var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueApexCharts',{attrs:{"type":"bar","options":_vm.IPCData.options,"series":_vm.IPCData.series}})}
var staticRenderFns = []

export { render, staticRenderFns }